import { useState } from "react";
import { Note } from "../../components/Note";
import { API } from "../../core/api";

const useServiceCenterStock = () => {
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({
    service_center_id: null,
    product_id: null,
    origin: null,
  });
  const [serviceCenterStocks, setServiceCenterStocks] = useState(null);

  const handleChange = (data) => {
    setState({
        ...state,
        ...data,
    })
  }

  const getServiceCenterStocks = () => {
    if (!state.service_center_id) {
     return Note.error("مرکز الزامی است");
    }
    setLoading(true);
    API.get.service_center_stocks(state).then((response) => {
      setLoading(false);
      if (response.success) {
        setServiceCenterStocks(response.data);
      }else {
        setServiceCenterStocks(null);
        Note.error(response.message)
      }
    });
  };

  return [loading, state, handleChange, serviceCenterStocks, getServiceCenterStocks];
};

export default useServiceCenterStock;
